import { SixPageWrapper } from '../../components/SixPageWrapper/SixPageWrapper';
import { MenuItems } from '../../types/MenuItems';
import { SixSectionWrapper } from '../../components/SixSectionWrapper/SixSectionWrapper';
import { getTranslation } from '../../constants/translations';

import image1 from '../../assets/images/marketing/marketing_page_1.webp';
import image2 from '../../assets/images/marketing/marketing_page_2.png';
import image3 from '../../assets/images/marketing/marketing_page_3.webp';
import image4 from '../../assets/images/marketing/marketing_page_4.png';
import image5 from '../../assets/images/marketing/marketing_page_5.webp';

import './Marketing.scss';

const images = [image1, image2, image3, image4, image5];

export const Marketing = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);
  const t = getTranslation();

  return (
    <>
      <SixPageWrapper
        section={MenuItems.MARKETING}
        title={t.MARKETING.title}
        itemsList={t.MARKETING.subsections.map((ss, i) => ({
          ...ss,
          link: `#${MenuItems.MARKETING}-page-${i + 1}`,
        }))}
      />

      {t.MARKETING.subsections.map((subsection, i) => (
        <SixSectionWrapper
          key={i}
          id={`${MenuItems.MARKETING}-page-${i + 1}`}
          color={style.getPropertyValue('--light-orange')}
          imgURL={images[i]}
          title={subsection.title}
          textContent={subsection.content}
        />
      ))}
    </>
  );
};
